
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import {Component} from "react";
import {connect} from "react-redux";
import {UpperScreen} from "../../../actions/terminal";
import Config from "../../../config/main";
import { broadcast, broadcastChannels } from "../../../helpers/broadcast";
import Helpers from "../../../helpers/helperFunctions";

class GameInfo extends Component {
    constructor (props) {
        super(props);
        this.state = {
            statisticsOpened: Config.terminal.disabledAutoOpenGameStatistics ? null : true
        };
        this.openStatistics = this.openStatistics.bind(this);
    }

    openStatistics (gameId) {
        return () => {
            this.setState({
                statisticsOpened: true
            });

            Helpers.isSplitScreenAvailable()
                ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                    detail: { command: 'Statistics', id: gameId, url: "", providerId: 0 }
                })) : this.props.dispatch(UpperScreen({type: "Statistics", id: gameId, videoURL: "", tv_type: 0}));
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

export default connect()(GameInfo);